import '@mdi/font/css/materialdesignicons.css'
import './site.scss'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import PortalVue from 'portal-vue'
import VuetifyConfirm from 'vuetify-confirm'
import { Chart, Filler, LinearScale, LineController, LineElement, PointElement, ScatterController, Title } from 'chart.js';

Vue.use(Vuetify);
Vue.use(PortalVue);
Chart.register(LinearScale, LineController, LineElement, ScatterController, PointElement, Filler, Title)

const vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
});

Vue.use(VuetifyConfirm, {vuetify })
export default vuetify
